const safeShowIf = (formData, condition) => {
  if (!formData || typeof formData !== 'object') return false;
  try {
    return condition(formData);
  } catch (error) {
    console.warn('Error in safeShowIf condition:', error);
    return false;
  }
};

export const FORM_CONFIGS = {
  users: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'users.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'firstName',
        type: 'text',
        label: 'form.fields.firstName',
        placeholder: 'form.placeholders.enterName',
        required: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'users.form.validation.firstNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'lastName',
        type: 'text',
        label: 'form.fields.lastName',
        placeholder: 'form.placeholders.enterName',
        required: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'users.form.validation.lastNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'email',
        type: 'email',
        label: 'form.fields.email',
        placeholder: 'form.placeholders.enterEmail',
        required: true,
        fullWidth: true,
        autoComplete: 'email',
        validation: {
          required: true,
          email: true,
          requiredMessage: 'users.form.validation.emailRequired',
          emailMessage: 'Geçerli bir e-posta adresi girin',
        },
      },
      {
        name: 'password',
        type: 'password',
        label: 'form.fields.password',
        placeholder: 'form.placeholders.enterPassword',
        required: (userData, currentUser, isEditMode) => !isEditMode,
        fullWidth: true,
        autoComplete: 'new-password',
        validation: {
          required: (userData, currentUser, isEditMode) => !isEditMode,
          minLength: 6,
          pattern:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
          requiredMessage: 'users.form.validation.passwordRequired',
          minLengthMessage: 'En az 6 karakter olmalıdır',
          patternMessage: t => t('modals.form.validation.passwordPattern'),
        },
      },
      {
        name: 'phoneNumber',
        type: 'phone',
        label: 'form.fields.phoneNumber',
        placeholder: 'form.placeholders.enterPhone',
        required: true,
        validation: {
          required: true,
          minLength: 12,
          maxLength: 13,
          requiredMessage: 'users.form.validation.phoneRequired',
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
      {
        name: 'workPhoneNumber',
        type: 'phone',
        label: 'form.fields.workPhoneNumber',
        placeholder: 'form.placeholders.enterWorkPhone',
        required: false,
        validation: {
          required: false,
          minLength: 12,
          maxLength: 13,
          requiredMessage: 'users.form.validation.workPhoneNumberRequired',
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
      {
        name: 'birthDate',
        type: 'date',
        label: 'form.fields.birthDate',
        placeholder: 'form.placeholders.selectDate',
      },
      {
        name: 'address',
        type: 'textarea',
        label: 'form.fields.address',
        placeholder: 'form.placeholders.enterAddress',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'isExpenseManager',
        type: 'select',
        label: 'form.fields.isExpenseManager',
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
      },
      {
        name: 'isLoanRequestManager',
        type: 'select',
        label: 'form.fields.isLoanRequestManager',
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
      },
      {
        name: 'managesCollections',
        type: 'select',
        label: 'form.fields.managesCollections',
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
      },
      {
        name: 'canViewCommunicationReport',
        type: 'select',
        label: 'form.fields.canViewCommunicationReport',
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
        // Sadece ROOT veya DIRECTOR bu alani gorebilir/duzenleyebilir.
        // Hasura update_permissions de bu kisitlamayi sunucu tarafinda zorlar.
      },
      {
        name: 'role',
        type: 'select',
        label: 'form.fields.role',
        required: true,
        options: [
          { value: 'TEAM_MEMBER', labelKey: 'roles.teamMember' },
          { value: 'TEAM_MANAGER', labelKey: 'roles.teamManager' },
          { value: 'GROUP_MANAGER', labelKey: 'roles.groupManager' },
          { value: 'DIRECTOR', labelKey: 'roles.director' },
          { value: 'ROOT', labelKey: 'roles.root' },
        ],
        validation: {
          required: true,
          requiredMessage: 'users.form.validation.roleRequired',
        },
      },
      {
        name: 'titleId',
        type: 'select',
        label: 'form.fields.title',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'users.form.validation.titleRequired',
        },
      },
      {
        name: 'teamId',
        type: 'select',
        label: 'form.fields.team',
        options: [],
      },
      {
        name: 'workStartDate',
        type: 'date',
        label: 'form.fields.workStartDate',
        placeholder: 'form.placeholders.selectDate',
        required: true,
        width: '50%',
        validation: {
          required: true,
          requiredMessage: 'users.form.validation.startDateRequired',
        },
      },
      {
        name: 'workEndDate',
        type: 'date',
        label: 'form.fields.workEndDate',
        placeholder: 'form.placeholders.selectDate',
        width: '50%',
      },
    ],
    title: {
      add: 'form.titles.addUser',
      edit: 'form.titles.editUser',
    },
  },

  groups: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'groups.form.validation.companyRequired',
        },
        showIf: (groupData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'form.fields.groupName',
        placeholder: 'form.placeholders.enterGroupName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'groups.form.validation.groupNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'form.fields.description',
        placeholder: 'form.placeholders.enterDescription',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'managerId',
        type: 'select',
        label: 'form.fields.groupManager',
        options: [],
        validation: {
          custom: 'validateGroupManager',
        },
      },
      {
        name: 'tagIds',
        type: 'multiselect',
        label: 'form.fields.tags',
        placeholder: 'form.placeholders.selectTags',
        required: false,
        fullWidth: true,
        options: [],
        validation: {
          custom: 'validateGroupTags',
        },
      },
    ],
    title: {
      add: 'form.titles.addGroup',
      edit: 'form.titles.editGroup',
    },
  },

  companies: {
    fields: [
      {
        name: 'name',
        type: 'text',
        label: 'form.fields.companyName',
        placeholder: 'form.placeholders.enterCompanyName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'companies.form.validation.firmNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'name_of_representative_',
        type: 'text',
        label: 'form.fields.representativeName',
        placeholder: 'form.placeholders.enterRepresentativeName',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage:
            'companies.form.validation.representativeNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'email_address_of_representative',
        type: 'email',
        label: 'form.fields.representativeEmail',
        placeholder: 'form.placeholders.enterRepresentativeEmail',
        required: true,
        fullWidth: true,
        autoComplete: 'email',
        validation: {
          required: true,
          email: true,
          requiredMessage:
            'companies.form.validation.representativeEmailRequired',
          emailMessage: 'Geçerli bir e-posta adresi girin',
        },
      },
      {
        name: 'phone_of_representative',
        type: 'phone',
        label: 'form.fields.representativePhone',
        placeholder: 'form.placeholders.enterRepresentativePhone',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 12,
          maxLength: 13,
          requiredMessage:
            'companies.form.validation.representativePhoneRequired',
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
    ],
    title: {
      add: 'form.titles.addCompany',
      edit: 'form.titles.editCompany',
    },
  },

  teams: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'teams.form.validation.companyRequired',
        },
        showIf: (groupData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'groupId',
        type: 'select',
        label: 'form.fields.group',
        options: [],
        validation: {
          custom: 'validateTeamGroup',
        },
      },
      {
        name: 'name',
        type: 'text',
        label: 'form.fields.teamName',
        placeholder: 'form.placeholders.enterTeamName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'teams.form.validation.teamNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'teamManagerId',
        type: 'select',
        label: 'form.fields.teamManager',
        options: [],
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'form.fields.description',
        placeholder: 'form.placeholders.enterDescription',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'tagIds',
        type: 'multiselect',
        label: 'form.fields.tags',
        placeholder: 'form.placeholders.selectTags',
        required: false,
        fullWidth: true,
        options: [],
        validation: {
          custom: 'validateTeamTags',
        },
      },
    ],
    title: {
      add: 'form.titles.addTeam',
      edit: 'form.titles.editTeam',
    },
  },

  teamMembers: {
    fields: [
      {
        name: 'userId',
        type: 'select',
        label: 'form.fields.selectUser',
        placeholder: 'Takıma eklenecek kullanıcıyı seçin',
        required: true,
        fullWidth: true,
        autoFocus: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'teams.form.validation.userRequired',
        },
      },
    ],
    title: {
      add: 'form.titles.addMemberToTeam',
      edit: 'form.titles.editMember',
    },
  },

  userFirms: {
    fields: [
      {
        name: 'firmIds',
        type: 'multiselect',
        label: 'userFirms.selectFirm',
        placeholder: 'userFirms.selectFirmPlaceholder',
        required: true,
        fullWidth: true,
        autoFocus: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'userFirms.validation.firmRequired',
        },
      },
    ],
    title: {
      add: 'userFirms.addFirmToUser',
      edit: 'userFirms.addFirmToUser',
    },
  },

  titles: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'titles.form.validation.companyRequired',
        },
        showIf: (titleData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'form.fields.titleName',
        placeholder: 'form.placeholders.enterTitleName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'titles.form.validation.titleNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'code',
        type: 'text',
        label: 'form.fields.code',
        placeholder: 'form.placeholders.enterCode',
        required: true,
        validation: {
          required: true,
          pattern: /^[A-Z0-9_]+$/,
          requiredMessage: 'titles.form.validation.codeRequired',
          patternMessage: 'Sadece büyük harf, rakam ve _ kullanılabilir',
        },
      },
      {
        name: 'status',
        type: 'select',
        label: 'form.fields.status',
        required: true,
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
        validation: {
          required: true,
          requiredMessage: 'titles.form.validation.statusRequired',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'form.fields.description',
        placeholder: 'form.placeholders.enterDescription',
        fullWidth: true,
        rows: 3,
      },
    ],
    title: {
      add: 'form.titles.addTitle',
      edit: 'form.titles.editTitle',
    },
  },

  profile: {
    fields: [
      {
        name: 'firstName',
        type: 'text',
        label: 'form.fields.firstName',
        required: true,
        section: 'personal',
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'profile.form.validation.firstNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'lastName',
        type: 'text',
        label: 'form.fields.lastName',
        required: true,
        section: 'personal',
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'profile.form.validation.lastNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'email',
        type: 'email',
        label: 'form.fields.email',
        required: true,
        section: 'personal',
        fullWidth: true,
        validation: {
          required: true,
          email: true,
          requiredMessage: 'profile.form.validation.emailRequired',
          emailMessage: 'Geçerli bir e-posta adresi girin',
        },
      },
      {
        name: 'role',
        type: 'select',
        label: 'form.fields.role',
        required: true,
        section: 'work',
        options: [
          { value: 'TEAM_MEMBER', labelKey: 'roles.teamMember' },
          { value: 'TEAM_MANAGER', labelKey: 'roles.teamManager' },
          { value: 'GROUP_MANAGER', labelKey: 'roles.groupManager' },
          { value: 'DIRECTOR', labelKey: 'roles.director' },
          { value: 'ROOT', labelKey: 'roles.root' },
        ],
        validation: {
          required: true,
          requiredMessage: 'profile.form.validation.roleRequired',
        },
      },
      {
        name: 'title',
        type: 'select',
        label: 'form.fields.title',
        required: true,
        section: 'work',
        options: [],
        validation: {
          required: true,
          requiredMessage: 'profile.form.validation.titleRequired',
        },
      },

      {
        name: 'companyPhone',
        type: 'text',
        label: 'form.fields.companyPhone',
        section: 'contact',
        validation: {
          pattern: /^(\+90|0)?[0-9]{10}$/,
          patternMessage: 'Geçerli bir telefon numarası girin',
        },
      },
      {
        name: 'personalPhone',
        type: 'phone',
        label: 'form.fields.personalPhone',
        required: true,
        section: 'contact',
        placeholder: 'form.placeholders.enterPhone',
        validation: {
          required: true,
          minLength: 12,
          maxLength: 13,
          requiredMessage: 'profile.form.validation.personalPhoneRequired',
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
      {
        name: 'address',
        type: 'textarea',
        label: 'form.fields.address',
        section: 'contact',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'emergencyContactName',
        type: 'text',
        label: 'form.fields.emergencyContactName',
        section: 'emergency',
        fullWidth: true,
      },
      {
        name: 'relationshipDegree',
        type: 'select',
        label: 'form.fields.relationshipDegree',
        section: 'emergency',
        options: [
          { value: 'anne', labelKey: 'profile.relationships.mother' },
          { value: 'baba', labelKey: 'profile.relationships.father' },
          { value: 'es', labelKey: 'profile.relationships.spouse' },
          { value: 'kardes', labelKey: 'profile.relationships.sibling' },
          { value: 'cocuk', labelKey: 'profile.relationships.child' },
        ],
      },
      {
        name: 'emergencyContactPhone',
        type: 'text',
        label: 'form.fields.emergencyContactPhone',
        section: 'emergency',
        validation: {
          pattern: /^(\+90|0)?[0-9]{10}$/,
          patternMessage: 'Geçerli bir telefon numarası girin',
        },
      },
    ],
    title: {
      edit: 'profile.editProfile',
    },
  },

  expenseTypes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'Şirket seçimi gereklidir',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'expense_type_name',
        type: 'text',
        label: 'expenseTypes.form.name',
        placeholder: 'expenseTypes.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'expenseTypes.form.validation.required',
          minLengthMessage: 'expenseTypes.form.validation.minLength',
        },
      },
      {
        name: 'expense_type_description',
        type: 'textarea',
        label: 'expenseTypes.form.description',
        placeholder: 'expenseTypes.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'expense_type_status',
        type: 'select',
        label: 'expenseTypes.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'expenseTypes.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'expenseTypes.form.titles.add',
      edit: 'expenseTypes.form.titles.edit',
    },
  },

  leaveTypes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'leaveTypes.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'leave_type_name',
        type: 'text',
        label: 'leaveTypes.form.name',
        placeholder: 'leaveTypes.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'leaveTypes.form.validation.required',
          minLengthMessage: 'leaveTypes.form.validation.minLength',
        },
      },
      {
        name: 'leave_type_description',
        type: 'textarea',
        label: 'leaveTypes.form.description',
        placeholder: 'leaveTypes.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'leave_type_status',
        type: 'select',
        label: 'leaveTypes.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'leaveTypes.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'leaveTypes.form.statusActive' },
          { value: 'inactive', label: 'leaveTypes.form.statusInactive' },
        ],
      },
      {
        name: 'leave_type_days',
        type: 'number',
        label: 'leaveTypes.form.days',
        placeholder: 'leaveTypes.form.placeholders.days',
        fullWidth: true,
        validation: {
          min: 0,
          minMessage: 'leaveTypes.form.validation.daysMin',
          pattern: /^\d*\.?\d*$/,
          patternMessage: 'leaveTypes.form.validation.daysPattern',
        },
        inputProps: {
          step: 1,
          min: 0,
        },
      },
      {
        name: 'leave_type_hours',
        type: 'number',
        label: 'leaveTypes.form.hours',
        placeholder: 'leaveTypes.form.placeholders.hours',
        fullWidth: true,
        validation: {
          min: 0,
          minMessage: 'leaveTypes.form.validation.hoursMin',
          pattern: /^\d*\.?\d*$/,
          patternMessage: 'leaveTypes.form.validation.hoursPattern',
        },
        inputProps: {
          step: 1,
          min: 0,
        },
      },
      {
        name: 'leave_type_deduct_from_annual_leave',
        type: 'select',
        label: 'leaveTypes.form.deductFromAnnualLeave',
        required: true,
        validation: {
          required: true,
          requiredMessage:
            'leaveTypes.form.validation.deductFromAnnualLeaveRequired',
        },
        options: [
          { value: true, label: 'leaveTypes.form.yes' },
          { value: false, label: 'leaveTypes.form.no' },
        ],
      },
    ],
    title: {
      add: 'leaveTypes.form.titles.add',
      edit: 'leaveTypes.form.titles.edit',
    },
  },

  partners: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'partners.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'partner_name',
        type: 'text',
        label: 'partners.form.name',
        placeholder: 'partners.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'partners.form.validation.required',
          minLengthMessage: 'partners.form.validation.minLength',
        },
      },
      {
        name: 'partner_description',
        type: 'textarea',
        label: 'partners.form.description',
        placeholder: 'partners.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'partner_status',
        type: 'select',
        label: 'partners.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'partners.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'partners.form.titles.add',
      edit: 'partners.form.titles.edit',
    },
  },

  sectors: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'sectors.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'sector_name',
        type: 'text',
        label: 'sectors.form.name',
        placeholder: 'sectors.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'sectors.form.validation.required',
          minLengthMessage: 'sectors.form.validation.minLength',
        },
      },
      {
        name: 'sector_description',
        type: 'textarea',
        label: 'sectors.form.description',
        placeholder: 'sectors.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'sector_status',
        type: 'select',
        label: 'sectors.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'sectors.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'sectors.form.titles.add',
      edit: 'sectors.form.titles.edit',
    },
  },

  contractSubjects: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contractSubjects.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'contractSubjects.form.name',
        placeholder: 'contractSubjects.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'contractSubjects.form.validation.required',
          minLengthMessage: 'contractSubjects.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'contractSubjects.form.description',
        placeholder: 'contractSubjects.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'isProjectBased',
        type: 'select',
        label: 'contractSubjects.form.isProjectBased',
        required: true,
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
        validation: {
          required: true,
          requiredMessage:
            'contractSubjects.form.validation.isProjectBasedRequired',
        },
      },
      {
        name: 'status',
        type: 'select',
        label: 'contractSubjects.form.status',
        required: true,
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
        validation: {
          required: true,
          requiredMessage: 'contractSubjects.form.validation.statusRequired',
        },
      },
    ],
    title: {
      add: 'contractSubjects.form.titles.add',
      edit: 'contractSubjects.form.titles.edit',
    },
  },

  jobTypes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobTypes.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'jobTypes.form.name',
        placeholder: 'jobTypes.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'jobTypes.form.validation.required',
          minLengthMessage: 'jobTypes.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'jobTypes.form.description',
        placeholder: 'jobTypes.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'isProjectBased',
        type: 'select',
        label: 'jobTypes.form.isProjectBased',
        required: true,
        options: [
          { value: true, label: 'common.yes' },
          { value: false, label: 'common.no' },
        ],
        validation: {
          required: true,
          requiredMessage: 'jobTypes.form.validation.isProjectBasedRequired',
        },
      },
      {
        name: 'statusGroup',
        type: 'select',
        label: 'jobTypes.form.statusGroup',
        required: true,
        options: [
          { value: 'standard', label: 'jobTypes.statusGroups.standard' },
          { value: 'phased', label: 'jobTypes.statusGroups.phased' },
        ],
        validation: {
          required: true,
          requiredMessage: 'jobTypes.form.validation.statusGroupRequired',
        },
      },
      {
        name: 'status',
        type: 'select',
        label: 'jobTypes.form.status',
        required: true,
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
        validation: {
          required: true,
          requiredMessage: 'jobTypes.form.validation.statusRequired',
        },
      },
    ],
    title: {
      add: 'jobTypes.form.titles.add',
      edit: 'jobTypes.form.titles.edit',
    },
  },

  scopeOfWork: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'scopeOfWork.form.name',
        placeholder: 'scopeOfWork.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'scopeOfWork.form.validation.required',
          minLengthMessage: 'scopeOfWork.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'scopeOfWork.form.description',
        placeholder: 'scopeOfWork.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'status',
        type: 'select',
        label: 'scopeOfWork.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'scopeOfWork.form.validation.statusRequired',
        },
        options: [
          { value: 'active', labelKey: 'scopeOfWork.form.statusActive' },
          { value: 'inactive', labelKey: 'scopeOfWork.form.statusInactive' },
        ],
      },
    ],
    title: {
      add: 'scopeOfWork.form.titles.add',
      edit: 'scopeOfWork.form.titles.edit',
    },
  },

  pricingMethods: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'pricingMethods.form.name',
        placeholder: 'pricingMethods.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'pricingMethods.form.validation.required',
          minLengthMessage: 'pricingMethods.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'pricingMethods.form.description',
        placeholder: 'pricingMethods.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'status',
        type: 'select',
        label: 'pricingMethods.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'pricingMethods.form.validation.statusRequired',
        },
        options: [
          { value: 'active', labelKey: 'pricingMethods.form.statusActive' },
          { value: 'inactive', labelKey: 'pricingMethods.form.statusInactive' },
        ],
      },
    ],
    title: {
      add: 'pricingMethods.form.titles.add',
      edit: 'pricingMethods.form.titles.edit',
    },
  },

  workStatus: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'workStatus.form.name',
        placeholder: 'workStatus.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'workStatus.form.validation.required',
          minLengthMessage: 'workStatus.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'workStatus.form.description',
        placeholder: 'workStatus.form.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'status',
        type: 'select',
        label: 'workStatus.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'workStatus.form.validation.statusRequired',
        },
        options: [
          { value: 'active', labelKey: 'workStatus.form.statusActive' },
          { value: 'inactive', labelKey: 'workStatus.form.statusInactive' },
        ],
      },
    ],
    title: {
      add: 'workStatus.form.titles.add',
      edit: 'workStatus.form.titles.edit',
    },
  },

  tags: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'tags.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'tags.form.name',
        placeholder: 'tags.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'tags.form.validation.required',
          minLengthMessage: 'tags.form.validation.minLength',
        },
      },
      {
        name: 'tags_color',
        type: 'color',
        label: 'tags.form.color',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'tags.form.validation.colorRequired',
        },
      },
      {
        name: 'tags_page',
        type: 'select',
        label: 'tags.form.page',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'tags.form.validation.pageRequired',
        },
        options: [
          { value: 'JOBS', labelKey: 'tags.pages.jobs' },
          { value: 'TEAMS', labelKey: 'tags.pages.teams' },
          { value: 'GROUPS', labelKey: 'tags.pages.groups' },
        ],
      },
    ],
    title: {
      add: 'tags.form.titles.add',
      edit: 'tags.form.titles.edit',
    },
  },

  documentBankTags: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'documentBankTags.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'documentBankTags.form.name',
        placeholder: 'documentBankTags.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'documentBankTags.form.validation.required',
          minLengthMessage: 'documentBankTags.form.validation.minLength',
        },
      },
      {
        name: 'color',
        type: 'color',
        label: 'documentBankTags.form.color',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'documentBankTags.form.validation.colorRequired',
        },
      },
    ],
    title: {
      add: 'documentBankTags.form.titles.add',
      edit: 'documentBankTags.form.titles.edit',
    },
  },

  firms: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'firms.form.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'is_established',
        type: 'radio',
        label: 'firms.form.isEstablished',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.firmEstablishedRequired',
        },
        options: [
          { value: 'yes', label: 'firms.options.yes' },
          { value: 'no', label: 'firms.options.no' },
        ],
        helpText: 'Hayırsa Firma Adı zorunlu olmayacak',
      },
      {
        name: 'firm_name',
        type: 'firmSuggestion',
        label: 'firms.form.firmName',
        placeholder: 'firms.form.placeholders.firmName',
        required: true,
        fullWidth: true,
        validation: {
          required: formData => formData?.is_established === 'yes',
          minLength: 2,
          requiredMessage: 'firms.form.validation.firmNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
        showIf: formData =>
          safeShowIf(formData, data => data.is_established === 'yes'),
      },
      {
        name: 'firm_short_name',
        type: 'firmSuggestion',
        label: 'firms.form.firmShortName',
        placeholder: 'firms.form.placeholders.firmShortName',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'firms.form.validation.firmShortNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },

      {
        name: 'sector_ids',
        type: 'multiselect',
        label: 'firms.form.sectors',
        placeholder: 'firms.form.placeholders.sectors',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.sectorsRequired',
        },
        options: [],
      },
      {
        name: 'firm_city',
        type: 'customselect',
        label: 'firms.form.city',
        placeholder: 'firms.form.placeholders.city',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.cityRequired',
        },
        options: [],
        allowCustom: true,
        customLabel: 'firms.options.international',
        customValue: 'yurtdisi',
      },
      {
        name: 'partner_referral',
        type: 'radio',
        label: 'firms.form.partnerReferral',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.partnerReferralRequired',
        },
        options: [
          { value: 'yes', label: 'firms.options.yes' },
          { value: 'no', label: 'firms.options.no' },
        ],
      },
      {
        name: 'partner_ids',
        type: 'multiselect',
        label: 'firms.form.partners',
        placeholder: 'firms.form.placeholders.partners',
        fullWidth: true,
        validation: {
          required: formData => formData?.partner_referral === 'yes',
          requiredMessage: 'firms.form.validation.partnerRequired',
        },
        options: [],
        showIf: formData =>
          safeShowIf(formData, data => data.partner_referral === 'yes'),
      },
      {
        name: 'reference_type',
        type: 'radio',
        label: 'firms.form.referenceType',
        required: true,
        defaultValue: 'none',
        validation: {
          required: true,
          requiredMessage: 'firms.form.validation.referenceTypeRequired',
        },
        options: [
          { value: 'existing', label: 'firms.options.existing' },
          { value: 'new', label: 'firms.options.new' },
          { value: 'none', label: 'firms.options.none' },
        ],
      },
      {
        name: 'reference_firm_id',
        type: 'select',
        label: 'firms.form.referenceCompany',
        placeholder: 'firms.form.placeholders.referenceCompany',
        fullWidth: true,
        validation: {
          required: formData => formData?.reference_type === 'existing',
          requiredMessage: 'firms.form.validation.referenceCompanyRequired',
        },
        options: [],
        showIf: formData =>
          safeShowIf(formData, data => data.reference_type === 'existing'),
      },
      {
        name: 'reference_text',
        type: 'text',
        label: 'firms.form.referenceText',
        placeholder: 'firms.form.placeholders.referenceText',
        fullWidth: true,
        validation: {
          required: formData => formData?.reference_type === 'new',
          requiredMessage: 'firms.form.validation.referenceTextRequired',
        },
        showIf: formData =>
          safeShowIf(formData, data => data.reference_type === 'new'),
      },
      {
        name: 'luca_code',
        type: 'text',
        label: 'firms.form.lucaCode',
        placeholder: 'firms.form.placeholders.lucaCode',
        fullWidth: true,
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'firms.form.description',
        placeholder: 'firms.form.placeholders.description',
        fullWidth: true,
        rows: 4,
      },
    ],
    title: {
      add: 'firms.form.titles.add',
      edit: 'firms.form.titles.edit',
    },
  },

  leaves: {
    fields: [
      {
        name: 'leaveType',
        type: 'select',
        label: 'leaves.form.leaveType',
        placeholder: 'leaves.form.placeholders.leaveType',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'leaves.form.validation.required',
        },
        options: [],
      },
      {
        name: 'startDate',
        type: 'datetime-local',
        label: 'leaves.form.startDate',
        placeholder: 'leaves.form.placeholders.startDate',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'leaves.form.validation.required',
        },
        disabled: formData => !formData?.leaveType,
      },
      {
        name: 'endDate',
        type: 'datetime-local',
        label: 'leaves.form.endDate',
        placeholder: 'leaves.form.placeholders.endDate',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'leaves.form.validation.required',
        },
        disabled: formData => !formData?.leaveType,
      },
      {
        name: 'leave_request_description',
        type: 'textarea',
        label: 'leaves.form.description',
        placeholder: 'leaves.form.placeholders.description',
        required: false,
        fullWidth: true,
        rows: 3,
      },
    ],
    title: {
      add: 'leaves.form.titles.add',
      edit: 'leaves.form.titles.edit',
    },
  },

  expenses: {
    fields: [
      {
        name: 'expenseDate',
        type: 'date',
        label: 'expenses.form.expenseDate',
        placeholder: 'expenses.form.placeholders.expenseDate',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'expenses.form.validation.expenseDateRequired',
        },
      },
      {
        name: 'expenseType',
        type: 'select',
        label: 'expenses.form.expenseType',
        placeholder: 'expenses.form.placeholders.expenseType',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'expenses.form.validation.expenseTypeRequired',
        },
        options: [],
      },
      {
        name: 'amount',
        type: 'number',
        label: 'expenses.form.amount',
        placeholder: 'expenses.form.placeholders.amount',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          min: 0,
          requiredMessage: 'expenses.form.validation.amountRequired',
          minMessage: 'expenses.form.validation.amountMin',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'expenses.form.description',
        placeholder: 'expenses.form.placeholders.description',
        required: true,
        fullWidth: true,
        rows: 3,
        validation: {
          required: true,
          minLength: 10,
          requiredMessage: 'expenses.form.validation.descriptionRequired',
          minLengthMessage: 'expenses.form.validation.descriptionMinLength',
        },
      },
    ],
    title: {
      add: 'expenses.form.titles.add',
      edit: 'expenses.form.titles.edit',
    },
  },

  firm_cards: {
    fields: [
      {
        name: 'firm_cart_firstname',
        type: 'text',
        label: 'firms.firmCards.form.firstName',
        placeholder: 'firms.firmCards.form.placeholders.firstName',
        required: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'firm_cards.form.validation.firstNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'firm_cart_lastname',
        type: 'text',
        label: 'firms.firmCards.form.lastName',
        placeholder: 'firms.firmCards.form.placeholders.lastName',
        required: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'firm_cards.form.validation.lastNameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'firm_cart_title',
        type: 'text',
        label: 'firms.firmCards.form.title',
        placeholder: 'firms.firmCards.form.placeholders.title',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'firm_cards.form.validation.titleRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'firm_cart_mail',
        type: 'email',
        label: 'firms.firmCards.form.email',
        placeholder: 'firms.firmCards.form.placeholders.email',
        required: true,
        fullWidth: true,
        autoComplete: 'email',
        validation: {
          required: true,
          email: true,
          requiredMessage: 'firm_cards.form.validation.emailRequired',
          emailMessage: 'Geçerli bir e-posta adresi girin',
        },
      },
      {
        name: 'firm_cart_phone',
        type: 'phone',
        label: 'firms.firmCards.form.phone',
        placeholder: 'firms.firmCards.form.placeholders.phone',
        required: true,
        validation: {
          required: true,
          minLength: 12,
          maxLength: 13,
          requiredMessage: 'firm_cards.form.validation.phoneRequired',
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
      {
        name: 'firm_cart_second_phone',
        type: 'phone',
        label: 'firms.firmCards.form.secondPhone',
        placeholder: 'firms.firmCards.form.placeholders.secondPhone',
        required: false,
        validation: {
          minLength: 12,
          maxLength: 13,
          minLengthMessage: 'Telefon numarası en az 12 haneli olmalıdır',
          maxLengthMessage: 'Telefon numarası en fazla 13 haneli olmalıdır',
        },
      },
      {
        name: 'firm_cart_task',
        type: 'text',
        label: 'firms.firmCards.form.task',
        placeholder: 'firms.firmCards.form.placeholders.task',
        required: false,
        fullWidth: true,
      },
      {
        name: 'firm_cart_description',
        type: 'textarea',
        label: 'firms.firmCards.form.description',
        placeholder: 'firms.firmCards.form.placeholders.description',
        required: false,
        rows: 2,
        fullWidth: true,
      },
      {
        name: 'firm_cart_status',
        type: 'radio',
        label: 'firms.firmCards.form.status',
        required: true,
        defaultValue: 'yes',
        validation: {
          required: true,
          requiredMessage: 'firm_cards.form.validation.statusRequired',
        },
        options: [
          { value: 'yes', label: 'Aktif' },
          { value: 'no', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'firms.firmCards.form.titles.add',
      edit: 'firms.firmCards.form.titles.edit',
    },
  },

  contracts: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'firm_established',
        type: 'radio',
        label: 'contracts.form.firmEstablished',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.firmEstablishedRequired',
        },
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
      },
      {
        name: 'firmId',
        type: 'select',
        label: 'contracts.form.selectFirm',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'yes',
      },
      {
        name: 'firm_short_name',
        type: 'select',
        label: 'contracts.form.firmShortName',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'no',
      },
      {
        name: 'contract_description',
        type: 'textarea',
        label: 'contracts.form.contractDescription',
        required: false,
        maxLength: 50,
        fullWidth: true,
      },
      {
        name: 'work_started_without_contract',
        type: 'radio',
        label: 'contracts.form.workStartedWithoutContract',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage:
            'contracts.form.validation.workStartedWithoutContractRequired',
        },
        options: [
          { value: 'yes', label: 'contracts.form.options.came' },
          { value: 'no', label: 'contracts.form.options.didNotCome' },
        ],
      },
      {
        name: 'contract_subject_id',
        type: 'select',
        label: 'contracts.form.contractSubject',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.contractSubjectRequired',
        },
      },
      {
        name: 'scope_of_work_id',
        type: 'select',
        label: 'contracts.form.scopeOfWork',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.scopeOfWorkRequired',
        },
      },
      {
        // Ücretlendirme şekli sözleşme gelmemiş olsa da sorulur: prim/ciro
        // hesaplamaları pricing_method_id'ye bağlı, boş kalırsa prim tarafı
        // hesaplama yapamıyor.
        name: 'pricing_method_id',
        type: 'select',
        label: 'contracts.form.pricingMethod',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.pricingMethodRequired',
        },
      },
      {
        name: 'contract_signing_date',
        type: 'date',
        label: 'contracts.form.contractSigningDate',
        required: false,
        fullWidth: true,
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
      {
        name: 'auto_renewal',
        type: 'radio',
        label: 'contracts.form.autoRenewal',
        required: false,
        defaultValue: 'no',
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
      {
        name: 'period_end_renewal_required',
        type: 'radio',
        label: 'contracts.form.periodEndRenewalRequired',
        required: false,
        defaultValue: 'no',
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
        showIf: formData =>
          formData.work_started_without_contract === 'yes' &&
          formData.auto_renewal === 'no',
      },
      {
        name: 'renewal_period',
        type: 'text',
        label: 'contracts.form.renewalPeriod',
        placeholder: 'contracts.form.placeholders.renewalPeriod',
        required: false,
        fullWidth: true,
        showIf: formData =>
          formData.work_started_without_contract === 'yes' &&
          (formData.auto_renewal === 'yes' ||
            formData.period_end_renewal_required === 'yes'),
      },
      {
        name: 'first_price_increase_period',
        type: 'date',
        label: 'contracts.form.firstPriceIncreasePeriod',
        required: false,
        fullWidth: true,
        showIf: formData =>
          formData.work_started_without_contract === 'yes' &&
          formData.auto_renewal === 'yes',
      },
      {
        name: 'inflation_clause',
        type: 'radio',
        label: 'contracts.form.inflationClause',
        required: false,
        defaultValue: 'no',
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
      {
        name: 'work_start_date',
        type: 'date',
        label: 'contracts.form.workStartDate',
        required: false,
        fullWidth: true,
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
      {
        name: 'invoice_issue_date',
        type: 'date',
        label: 'contracts.form.invoiceIssueDate',
        required: false,
        fullWidth: true,
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
      {
        name: 'work_status_id',
        type: 'select',
        label: 'contracts.form.workStatus',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'contracts.form.validation.workStatusRequired',
        },
      },
      // Not: protocol_start_date / protocol_end_date / protocol_pdf alanları
      // Sözleşme Yenile aksiyonu içine taşındı (her yenileme döneminin kendi
      // protokol bilgisi var). Sözleşme oluşturma/düzenleme formunda artık
      // sadece sözleşme PDF'i kalır.
      {
        name: 'comment',
        type: 'textarea',
        label: 'contracts.form.comment',
        placeholder: 'contracts.form.placeholders.comment',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'contract_pdf',
        type: 'fileupload',
        label: 'contracts.form.contractPDF',
        required: false,
        fullWidth: true,
        showIf: formData => formData.work_started_without_contract === 'yes',
      },
    ],
    title: {
      add: 'contracts.form.titles.add',
      edit: 'contracts.form.titles.edit',
    },
  },

  proposal_status: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'proposalStatuses.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'name',
        type: 'text',
        label: 'proposalStatuses.form.name',
        placeholder: 'proposalStatuses.form.placeholders.name',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'proposalStatuses.form.validation.nameRequired',
          minLengthMessage: 'En az 2 karakter olmalıdır',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'proposalStatuses.form.description',
        placeholder: 'proposalStatuses.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'status',
        type: 'select',
        label: 'proposalStatuses.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'proposalStatuses.form.validation.statusRequired',
        },
        options: [
          { value: 'active', labelKey: 'proposalStatuses.form.statusActive' },
          {
            value: 'inactive',
            labelKey: 'proposalStatuses.form.statusInactive',
          },
        ],
      },
    ],
    title: {
      add: 'proposalStatuses.form.titles.add',
      edit: 'proposalStatuses.form.titles.edit',
    },
  },

  offers: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'offers.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'firm_established',
        type: 'radio',
        label: 'offers.form.firmEstablished',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'offers.form.validation.firmEstablishedRequired',
        },
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
      },
      {
        name: 'firmId',
        type: 'select',
        label: 'offers.form.selectFirm',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'yes',
      },
      {
        name: 'firm_short_name',
        type: 'select',
        label: 'offers.form.firmShortName',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'no',
      },
      {
        name: 'proposal_given',
        type: 'radio',
        label: 'offers.form.proposalGiven',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'offers.form.validation.offerGivenRequired',
        },
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
      },
      {
        name: 'contract_subject_id',
        type: 'select',
        label: 'offers.form.contractSubject',
        required: false,
        options: [],
        validation: {
          required: formData => formData.proposal_given === 'yes',
          requiredMessage: 'offers.form.validation.proposalSubjectRequired',
        },
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'scope_of_work_id',
        type: 'select',
        label: 'offers.form.scopeOfWork',
        required: false,
        options: [],
        validation: {
          required: formData => formData.proposal_given === 'yes',
          requiredMessage: 'offers.form.validation.scopeOfWorkRequired',
        },
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'proposal_date',
        type: 'date',
        label: 'offers.form.proposalDate',
        required: false,
        fullWidth: true,
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'proposal_file',
        type: 'fileupload',
        label: 'offers.form.proposalFile',
        required: false,
        fullWidth: true,
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'proposal_status_id',
        type: 'select',
        label: 'offers.form.proposalStatus',
        required: false,
        options: [],
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'revised_proposal_given',
        type: 'radio',
        label: 'offers.form.revisedProposalGiven',
        required: false,
        defaultValue: 'no',
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
        showIf: formData => formData.proposal_given === 'yes',
      },
      {
        name: 'revised_proposals',
        type: 'array',
        label: 'offers.form.revisedProposals',
        required: false,
        fullWidth: true,
        itemTitle: 'offers.form.revisedProposal',
        addButtonText: 'offers.form.addRevisedProposal',
        defaultItemStructure: {
          date: null,
          file: null,
          comment: '',
        },
        itemFields: [
          {
            name: 'date',
            type: 'date',
            label: 'offers.form.revisedProposalDate',
            required: false,
            fullWidth: true,
          },
          {
            name: 'file',
            type: 'fileupload',
            label: 'offers.form.revisedProposalFile',
            required: false,
            fullWidth: true,
          },
          {
            name: 'comment',
            type: 'textarea',
            label: 'offers.form.revisedProposalComment',
            placeholder: 'offers.form.placeholders.revisedProposalComment',
            required: false,
            fullWidth: true,
            rows: 3,
            maxLength: 50,
          },
        ],
        showIf: formData =>
          formData.proposal_given === 'yes' &&
          formData.revised_proposal_given === 'yes',
      },
      {
        name: 'comment',
        type: 'textarea',
        label: 'offers.form.comment',
        placeholder: 'offers.form.placeholders.comment',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'reminder_date',
        type: 'date',
        label: 'offers.form.reminderDate',
        required: false,
        fullWidth: true,
      },
      {
        name: 'reminder_note',
        type: 'textarea',
        label: 'offers.form.reminderNote',
        placeholder: 'offers.form.placeholders.reminderNote',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'sectorIds',
        type: 'multiselect',
        label: 'offers.form.sectors',
        placeholder: 'offers.form.placeholders.selectSectors',
        fullWidth: true,
        options: [],
      },
    ],
    title: {
      add: 'offers.form.titles.add',
      edit: 'offers.form.titles.edit',
    },
  },

  jobs: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobs.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'jobTitle',
        type: 'text',
        label: 'jobs.form.jobTitle',
        placeholder: 'jobs.form.placeholders.jobTitle',
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          requiredMessage: 'jobs.form.validation.jobTitleRequired',
        },
      },
      {
        name: 'firm_established',
        type: 'radio',
        label: 'contracts.form.firmEstablished',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'jobs.form.validation.firmEstablishedRequired',
        },
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
      },
      {
        name: 'firmId',
        type: 'select',
        label: 'contracts.form.selectFirm',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'yes',
      },
      {
        name: 'firm_short_name',
        type: 'select',
        label: 'contracts.form.firmShortName',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'no',
      },
      {
        name: 'contractId',
        type: 'select',
        label: 'jobs.form.contract',
        placeholder: 'jobs.form.placeholders.selectContract',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobs.form.validation.contractRequired',
        },
        showIf: formData => formData.firm_established,
      },
      {
        name: 'consultingScope',
        type: 'radio',
        label: 'jobs.form.consultingScope',
        required: false,
        defaultValue: 'MALI_TEKNIK',
        options: [
          { value: 'MALI_TEKNIK', label: 'jobs.form.consultingScopeOptions.maliTeknik' },
          { value: 'SADECE_TEKNIK', label: 'jobs.form.consultingScopeOptions.sadeceTeknik' },
          { value: 'SADECE_MALI', label: 'jobs.form.consultingScopeOptions.sadeceMali' },
        ],
      },
      {
        name: 'jobTypeId',
        type: 'select',
        label: 'jobs.form.jobType',
        placeholder: 'jobs.form.placeholders.selectJobType',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobs.form.validation.jobTypeRequired',
        },
      },
      {
        name: 'tagIds',
        type: 'multiselect',
        label: 'jobs.form.tags',
        placeholder: 'jobs.form.placeholders.selectTags',
        required: false,
        fullWidth: true,
        options: [],
        helperText: 'jobs.form.helperText.selectTags',
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'jobs.form.description',
        placeholder: 'jobs.form.placeholders.description',
        fullWidth: true,
        rows: 3,
        maxLength: 50,
      },
    ],

    title: {
      add: 'jobs.form.titles.add',
      edit: 'jobs.form.titles.edit',
    },
  },

  jobAssignments: {
    fields: [
      {
        name: 'firmId',
        type: 'select',
        label: 'jobAssignments.form.firm',
        placeholder: 'jobAssignments.form.placeholders.selectFirm',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobAssignments.form.validation.firmRequired',
        },
      },
      {
        name: 'jobId',
        type: 'select',
        label: 'jobAssignments.form.job',
        placeholder: 'jobAssignments.form.placeholders.selectJobAfterFirm',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'jobAssignments.form.validation.jobRequired',
        },
      },
      {
        name: 'teamId',
        type: 'select',
        label: 'form.fields.team',
        placeholder: 'form.placeholders.selectTeam',
        required: false,
        fullWidth: true,
        options: [],
      },
      {
        name: 'userId',
        type: 'select',
        label: 'jobAssignments.form.fields.user',
        placeholder: 'form.placeholders.selectUser',
        required: false,
        fullWidth: true,
        options: [],
      },
      {
        name: 'groupId',
        type: 'select',
        label: 'jobAssignments.form.fields.group',
        placeholder: 'form.placeholders.selectGroup',
        required: false,
        fullWidth: true,
        options: [],
      },
    ],
    title: {
      add: 'jobAssignments.form.titles.add',
      edit: 'jobAssignments.form.titles.edit',
    },
  },

  reportTypes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'reportTypes.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'report_type_name',
        type: 'text',
        label: 'reportTypes.form.name',
        placeholder: 'reportTypes.form.placeholders.name',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'reportTypes.form.validation.required',
          minLengthMessage: 'reportTypes.form.validation.minLength',
        },
      },
      {
        name: 'report_type_description',
        type: 'textarea',
        label: 'reportTypes.form.description',
        placeholder: 'reportTypes.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'report_type_status',
        type: 'select',
        label: 'reportTypes.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'reportTypes.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
      {
        name: 'report_type_tags',
        type: 'tags',
        label: 'reportTypes.form.tags',
        placeholder: 'reportTypes.form.placeholders.tagsEnter',
        fullWidth: true,
      },
    ],
    title: {
      add: 'reportTypes.form.titles.add',
      edit: 'reportTypes.form.titles.edit',
    },
  },

  tasks: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'firmId',
        type: 'select',
        label: 'tasks.form.firm',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.firmRequired',
        },
      },
      {
        name: 'taskTitle',
        type: 'text',
        label: 'tasks.form.title',
        placeholder: 'tasks.form.placeholders.title',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'tasks.form.validation.titleRequired',
          minLengthMessage: 'tasks.form.validation.minLength',
        },
      },
      {
        name: 'taskDescription',
        type: 'textarea',
        label: 'tasks.form.description',
        placeholder: 'tasks.form.placeholders.description',
        fullWidth: true,
        rows: 3,
        required: true,
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.descriptionRequired',
        },
      },
      {
        name: 'taskStartDate',
        type: 'date',
        label: 'tasks.form.startDate',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.startDateRequired',
        },
      },
      {
        name: 'taskDueDate',
        type: 'date',
        label: 'tasks.form.dueDate',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.dueDateRequired',
        },
      },
      {
        name: 'taskStatus',
        type: 'select',
        label: 'tasks.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'tasks.form.validation.statusRequired',
        },
        options: [
          { value: 'PENDING', label: 'tasks.form.statuses.pending' },
          { value: 'IN_PROGRESS', label: 'tasks.form.statuses.inProgress' },
          { value: 'COMPLETED', label: 'tasks.form.statuses.completed' },
          { value: 'CANCELLED', label: 'tasks.form.statuses.cancelled' },
        ],
      },
    ],
    title: {
      add: 'tasks.form.titles.add',
      edit: 'tasks.form.titles.edit',
    },
  },

  paymentPlanTemplates: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage:
            'paymentPlanTemplates.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'templateName',
        type: 'text',
        label: 'paymentPlanTemplates.form.templateName',
        placeholder: 'paymentPlanTemplates.form.placeholders.templateName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage:
            'paymentPlanTemplates.form.validation.templateNameRequired',
          minLengthMessage: 'paymentPlanTemplates.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'paymentPlanTemplates.form.description',
        placeholder: 'paymentPlanTemplates.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'year',
        type: 'number',
        label: 'paymentPlanTemplates.form.year',
        placeholder: 'paymentPlanTemplates.form.placeholders.year',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'paymentPlanTemplates.form.validation.yearRequired',
        },
      },
      {
        name: 'paymentSchedule',
        type: 'monthlySchedule',
        label: 'paymentPlanTemplates.form.paymentSchedule',
        required: true,
      },
      {
        name: 'status',
        type: 'select',
        label: 'paymentPlanTemplates.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage:
            'paymentPlanTemplates.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'paymentPlanTemplates.form.titles.add',
      edit: 'paymentPlanTemplates.form.titles.edit',
    },
  },

  pricingProcess: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'pricingProcess.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'processName',
        type: 'text',
        label: 'pricingProcess.form.processName',
        placeholder: 'pricingProcess.form.placeholders.processName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'pricingProcess.form.validation.processNameRequired',
          minLengthMessage: 'pricingProcess.form.validation.minLength',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'pricingProcess.form.description',
        placeholder: 'pricingProcess.form.placeholders.description',
        fullWidth: true,
        rows: 3,
      },
      {
        name: 'status',
        type: 'select',
        label: 'pricingProcess.form.status',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'pricingProcess.form.validation.statusRequired',
        },
        options: [
          { value: 'active', label: 'Aktif' },
          { value: 'inactive', label: 'Pasif' },
        ],
      },
    ],
    title: {
      add: 'pricingProcess.form.titles.add',
      edit: 'pricingProcess.form.titles.edit',
    },
  },

  invoices: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.companyRequired',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'invoice_name',
        type: 'text',
        label: 'invoices.form.invoiceName',
        placeholder: 'invoices.form.placeholders.invoiceName',
        fullWidth: true,
      },
      {
        name: 'firm_established',
        type: 'radio',
        label: 'contracts.form.firmEstablished',
        required: true,
        defaultValue: 'no',
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.firmEstablishedRequired',
        },
        options: [
          { value: 'yes', label: 'common.yes' },
          { value: 'no', label: 'common.no' },
        ],
      },
      {
        name: 'firmId',
        type: 'select',
        label: 'contracts.form.selectFirm',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'yes',
      },
      {
        name: 'firm_short_name',
        type: 'select',
        label: 'contracts.form.firmShortName',
        required: false,
        options: [],
        showIf: formData => formData.firm_established === 'no',
      },
      {
        name: 'contractId',
        type: 'select',
        label: 'invoices.form.contract',
        placeholder: 'invoices.form.placeholders.selectContract',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.contractRequired',
        },
        showIf: formData => {
          if (formData.firm_established === 'yes') {
            return formData.firmId; // Firma seçilmiş olmalı
          }
          if (formData.firm_established === 'no') {
            return formData.firm_short_name; // Firma kısa adı seçilmiş olmalı
          }
          return false;
        },
      },
      {
        name: 'jobId',
        type: 'select',
        label: 'invoices.form.job',
        placeholder: 'invoices.form.placeholders.selectJob',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.jobRequired',
        },
        showIf: formData => {
          if (formData.firm_established === 'yes') {
            return formData.firmId && formData.contractId; // Firma ve sözleşme seçilmiş olmalı
          }
          if (formData.firm_established === 'no') {
            return formData.firm_short_name && formData.contractId; // Firma kısa adı ve sözleşme seçilmiş olmalı
          }
          return false;
        },
      },
      {
        name: 'pricing_method_id',
        type: 'select',
        label: 'contracts.form.pricingMethod',
        required: false,
        options: [],
        disabled: true,
        helperText: 'invoices.form.pricingMethodHelperText',
        helperTextColor: 'error',
      },
      {
        name: 'contract_subject_name',
        type: 'select',
        label: 'contracts.form.contractSubject',
        required: false,
        options: [],
        disabled: true,
      },
      {
        name: 'change_pricing_method',
        type: 'checkbox',
        label: 'invoices.form.changePricingMethod',
        required: false,
        defaultValue: false,
      },
      {
        name: 'new_pricing_type',
        type: 'text',
        label: 'invoices.form.newPricingType',
        placeholder: 'invoices.form.placeholders.newPricingType',
        required: false,
        fullWidth: true,
        showIf: formData => formData.change_pricing_method === true,
      },
      {
        name: 'new_start_date',
        type: 'date',
        label: 'invoices.form.newStartDate',
        required: false,
        fullWidth: true,
        showIf: formData => formData.change_pricing_method === true,
      },
      {
        name: 'pricingProcessId',
        type: 'select',
        label: 'invoices.form.pricingProcess',
        placeholder: 'invoices.form.placeholders.selectPricingProcess',
        required: true,
        fullWidth: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.pricingProcessRequired',
        },
      },
      {
        name: 'split_invoice',
        type: 'select',
        label: 'invoices.form.splitInvoice',
        required: false,
        fullWidth: true,
        options: [
          { value: false, label: 'common.no' },
          { value: true, label: 'common.yes' },
        ],
      },
      {
        name: 'custom_date_range',
        type: 'select',
        label: 'invoices.form.customDateRange',
        required: false,
        fullWidth: true,
        options: [
          { value: false, label: 'common.no' },
          { value: true, label: 'common.yes' },
        ],
      },
      {
        name: 'date_range_start',
        type: 'date',
        label: 'invoices.form.dateRangeStart',
        required: false,
        fullWidth: true,
        showIf: formData =>
          formData.custom_date_range === true ||
          formData.custom_date_range === 'true' ||
          formData.custom_date_range === 1,
      },
      {
        name: 'date_range_end',
        type: 'date',
        label: 'invoices.form.dateRangeEnd',
        required: false,
        fullWidth: true,
        showIf: formData =>
          formData.custom_date_range === true ||
          formData.custom_date_range === 'true' ||
          formData.custom_date_range === 1,
      },
      {
        name: 'total_unit_price',
        type: 'number',
        label: 'invoices.form.totalUnitPrice',
        placeholder: 'invoices.form.placeholders.totalUnitPrice',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          requiredMessage: 'invoices.form.validation.totalUnitPriceRequired',
          custom: (value, formData) => {
            const totalPrice = parseFloat(value) || 0;
            if (formData.split_invoice === true) {
              const items = Array.isArray(formData.invoice_code_ids)
                ? formData.invoice_code_ids
                : [];
              const codesTotal = items.reduce(
                (sum, it) => sum + (parseFloat(it?.amount) || 0),
                0
              );
              if (codesTotal > 0 && Math.abs(codesTotal - totalPrice) > 0.01) {
                return 'invoices.form.validation.totalUnitPriceMismatch';
              }
              return null;
            }
            return null;
          },
        },
      },
      {
        name: 'invoice_code_ids',
        type: 'array',
        label: 'invoices.form.splitInvoiceCodes',
        required: false,
        showIf: formData => formData.split_invoice === true,
        itemTitle: 'invoices.form.splitInvoiceCode',
        addButtonText: 'invoices.form.addSplitInvoiceCode',
        defaultItemStructure: {
          invoice_code_id: null,
          amount: null,
          schedules: [],
        },
        itemFields: [
          {
            name: 'invoice_code_id',
            type: 'select',
            label: 'invoices.form.invoiceCode',
            options: [],
            disabled: false,
          },
          {
            name: 'amount',
            type: 'number',
            label: 'invoices.form.splitAmount',
            required: true,
            validation: {
              required: true,
              min: 0,
              requiredMessage: 'invoices.form.validation.splitAmountRequired',
            },
          },
          {
            name: 'schedules',
            type: 'paymentSchedule',
            label: 'invoices.form.paymentSchedules',
          },
        ],
      },
      {
        name: 'invoice_code_id',
        type: 'select',
        label: 'invoices.form.invoiceCode',
        required: false,
        fullWidth: true,
        options: [],
        showIf: formData => formData.split_invoice === false,
      },
      {
        name: 'payment_schedules',
        type: 'paymentSchedule',
        label: 'invoices.form.paymentSchedules',
        showIf: formData => {
          if (formData.split_invoice === false) {
            // Render only after the user explicitly answers the custom date range question
            const cdrYes =
              formData.custom_date_range === true ||
              formData.custom_date_range === 'true' ||
              formData.custom_date_range === 1;
            const cdrNo =
              formData.custom_date_range === false ||
              formData.custom_date_range === 'false' ||
              formData.custom_date_range === 0;
            if (cdrYes) {
              // If custom date range is enabled, wait for both dates
              return formData.date_range_start && formData.date_range_end;
            }
            if (cdrNo) {
              // If explicitly chosen as No, render with default logic
              return true;
            }
            // If not answered yet (undefined), do not render
            return false;
          }
          return false;
        },
        required: false,
        fullWidth: true,
      },
    ],
    title: {
      add: 'invoices.form.titles.add',
      edit: 'invoices.form.titles.edit',
    },
  },

  invoiceCodes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'Şirket seçimi gereklidir',
        },
        showIf: (userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'code_name',
        type: 'text',
        label: 'invoiceCode.form.codeName',
        placeholder: 'invoiceCode.form.placeholders.codeName',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'invoiceCode.form.validation.required',
          minLengthMessage: 'invoiceCode.form.validation.minLength',
        },
      },
      {
        name: 'product_name',
        type: 'text',
        label: 'invoiceCode.form.productName',
        required: true,
        validation: {
          required: true,
          requiredMessage: 'invoiceCode.form.validation.required',
        },
        placeholder: 'invoiceCode.form.placeholders.productName',
        fullWidth: true,
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'invoiceCode.form.description',
        required: false,
      },
    ],
    title: {
      add: 'invoiceCode.form.titles.add',
      edit: 'invoiceCode.form.titles.edit',
    },
  },

  // ─── Prim Yönetimi ──────────────────────────────────────────────────────
  bonusRevenueTypes: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'code',
        type: 'text',
        label: 'bonusRevenueTypes.form.code',
        placeholder: 'CT17',
        required: true,
        fullWidth: true,
        autoFocus: true,
        validation: {
          required: true,
          pattern: /^[A-Z]{2,4}[0-9]{1,4}$/,
          requiredMessage: 'bonusRevenueTypes.form.validation.codeRequired',
          patternMessage: 'bonusRevenueTypes.form.validation.codeFormat',
        },
      },
      {
        name: 'name',
        type: 'text',
        label: 'bonusRevenueTypes.form.name',
        placeholder: 'bonusRevenueTypes.form.placeholders.name',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          minLength: 2,
          requiredMessage: 'bonusRevenueTypes.form.validation.nameRequired',
        },
      },
      {
        name: 'coefficient',
        type: 'number',
        label: 'bonusRevenueTypes.form.coefficient',
        placeholder: '1.0',
        fullWidth: true,
        defaultValue: 1,
        step: 0.0001,
      },
      {
        name: 'applicable_channels',
        type: 'multiselect',
        label: 'bonusRevenueTypes.form.applicableChannels',
        fullWidth: true,
        options: [
          { value: 'SATIS_CIROSU',        labelKey: 'userRevenueEntries.kanal.SATIS_CIROSU' },
          { value: 'PROJE_YAZIM_CIROSU',  labelKey: 'userRevenueEntries.kanal.PROJE_YAZIM_CIROSU' },
          { value: 'ONAY_SONRASI_CIROSU', labelKey: 'userRevenueEntries.kanal.ONAY_SONRASI_CIROSU' },
        ],
      },
    ],
    title: {
      add: 'bonusRevenueTypes.form.titles.add',
      edit: 'bonusRevenueTypes.form.titles.edit',
    },
  },

  bonusRevenueRules: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'ciro_kanali',
        type: 'select',
        label: 'bonusRevenueRules.form.kanal',
        required: true,
        options: [
          { value: 'SATIS_CIROSU',        labelKey: 'bonusRevenueRules.kanal.SATIS_CIROSU' },
          { value: 'ONAY_SONRASI_CIROSU', labelKey: 'bonusRevenueRules.kanal.ONAY_SONRASI_CIROSU' },
          { value: 'PROJE_YAZIM_CIROSU',  labelKey: 'bonusRevenueRules.kanal.PROJE_YAZIM_CIROSU' },
        ],
        validation: { required: true, requiredMessage: 'bonusRevenueRules.form.validation.kanalRequired' },
      },
      {
        name: 'team_ids',
        type: 'multiselect',
        label: 'bonusRevenueRules.form.teams',
        options: [],   // sayfa tarafından useTeams ile doldurulur
        fullWidth: true,
        helperText: 'bonusRevenueRules.form.teamsHelp',
      },
      {
        name: 'operation',
        type: 'text',
        label: 'bonusRevenueRules.form.operation',
        placeholder: '(CT17+CT19)*CT21',
        required: true,
        fullWidth: true,
        validation: {
          required: true,
          pattern: /^[A-Z0-9+\-*/(). ]+$/,
          requiredMessage: 'bonusRevenueRules.form.validation.operationRequired',
          patternMessage: 'bonusRevenueRules.form.validation.operationFormat',
        },
      },
      {
        name: 'aciklama',
        type: 'textarea',
        label: 'bonusRevenueRules.form.aciklama',
        fullWidth: true,
        rows: 2,
      },
    ],
    title: {
      add: 'bonusRevenueRules.form.titles.add',
      edit: 'bonusRevenueRules.form.titles.edit',
    },
  },

  bonusRules: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'aciklama',
        type: 'text',
        label: 'bonusRules.form.aciklama',
        fullWidth: true,
        required: true,
        validation: { required: true, requiredMessage: 'bonusRules.form.validation.aciklamaRequired' },
      },
      {
        name: 'team_ids',
        type: 'multiselect',
        label: 'bonusRules.form.teams',
        options: [],
        fullWidth: true,
        helperText: 'bonusRules.form.teamsHelp',
      },
      {
        name: 'sabit_yuzdelik_aktif',
        type: 'switch',
        label: 'bonusRules.form.sabitYuzdelikAktif',
      },
      {
        name: 'sabit_yuzdelik_deger',
        type: 'number',
        label: 'bonusRules.form.sabitYuzdelikDeger',
        showIf: (formData) => !!formData.sabit_yuzdelik_aktif,
        step: 0.001,
      },
      { name: 'prim_hakedis_esik_orani', type: 'number', label: 'bonusRules.form.hakedisEsik', step: 0.001 },
      {
        name: 'baz_prim_orani', type: 'number', label: 'bonusRules.form.bazPrim', step: 0.001,
        // Sabit yüzdelik aktifse baz prim oranı kullanılmıyor; UI'da gizle.
        showIf: (formData) => !formData.sabit_yuzdelik_aktif,
      },
      {
        name: 'baslangic_yil', type: 'number', label: 'bonusRules.form.baslangicYil',
        required: true,
        defaultValue: new Date().getFullYear(),
        validation: { required: true, requiredMessage: 'bonusRules.form.validation.baslangicRequired' },
      },
      {
        name: 'baslangic_ceyrek', type: 'select', label: 'bonusRules.form.baslangicCeyrek',
        required: true,
        defaultValue: 1,
        options: [{ value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' }],
        validation: { required: true, requiredMessage: 'bonusRules.form.validation.baslangicRequired' },
      },
      // bitis_yil ve bitis_ceyrek opsiyonel: açık uçlu kural olabilir.
      { name: 'bitis_yil', type: 'number', label: 'bonusRules.form.bitisYil' },
      {
        name: 'bitis_ceyrek', type: 'select', label: 'bonusRules.form.bitisCeyrek',
        options: [
          { value: '', label: '—' },
          { value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' },
        ],
      },
      {
        name: 'status', type: 'select', label: 'bonusRules.form.status',
        options: [
          { value: 'active',   labelKey: 'common.active' },
          { value: 'inactive', labelKey: 'common.inactive' },
        ],
        defaultValue: 'active',
      },
    ],
    title: {
      add: 'bonusRules.form.titles.add',
      edit: 'bonusRules.form.titles.edit',
    },
  },

  bonusPayments: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'user_id',
        type: 'select',
        label: 'bonusPayments.form.user',
        required: true,
        options: [],
        validation: { required: true, requiredMessage: 'bonusPayments.form.validation.userRequired' },
      },
      {
        name: 'islem_turu',
        type: 'select',
        label: 'bonusPayments.form.islemTuru',
        required: true,
        options: [
          { value: 'HESAPLANAN_PRIM', labelKey: 'bonusPayments.islemTuru.HESAPLANAN_PRIM' },
          { value: 'EK_PRIM',         labelKey: 'bonusPayments.islemTuru.EK_PRIM' },
          { value: 'ODEME',           labelKey: 'bonusPayments.islemTuru.ODEME' },
        ],
        validation: { required: true, requiredMessage: 'bonusPayments.form.validation.islemTuruRequired' },
      },
      {
        name: 'tarih', type: 'date', label: 'bonusPayments.form.tarih',
        required: true,
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'yil', type: 'number', label: 'bonusPayments.form.yil',
        required: true,
        defaultValue: new Date().getFullYear(),
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'ceyrek', type: 'select', label: 'bonusPayments.form.ceyrek',
        required: true,
        defaultValue: 1,
        options: [{ value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' }],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'tutar', type: 'number', label: 'bonusPayments.form.tutar',
        required: true,
        step: 0.01,
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      { name: 'aciklama', type: 'textarea', label: 'bonusPayments.form.aciklama', rows: 2, fullWidth: true },
    ],
    title: {
      add: 'bonusPayments.form.titles.add',
      edit: 'bonusPayments.form.titles.edit',
    },
  },

  // ─── Kullanıcı Bazlı Prim Katsayıları (TASK B) ─────────────────────────
  userBonusCoefficients: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'user_id',
        type: 'select',
        label: 'userBonusCoefficients.form.user',
        required: true,
        options: [],
        validation: { required: true, requiredMessage: 'userBonusCoefficients.form.validation.userRequired' },
      },
      {
        name: 'yil', type: 'number', label: 'userBonusCoefficients.form.yil',
        required: true,
        defaultValue: new Date().getFullYear(),
        validation: { required: true, requiredMessage: 'userBonusCoefficients.form.validation.yilRequired' },
      },
      {
        name: 'ceyrek', type: 'select', label: 'userBonusCoefficients.form.ceyrek',
        required: true,
        defaultValue: 1,
        options: [{ value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' }],
        validation: { required: true, requiredMessage: 'userBonusCoefficients.form.validation.ceyrekRequired' },
      },
      {
        name: 'katsayi', type: 'number', label: 'userBonusCoefficients.form.katsayi',
        required: true, step: 0.001, defaultValue: 1,
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
    ],
    title: {
      add: 'userBonusCoefficients.form.titles.add',
      edit: 'userBonusCoefficients.form.titles.edit',
    },
  },

  // ─── Çeyreklik Prim Hedefleri (TASK E) ─────────────────────────────────
  bonusTargets: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'yil', type: 'number', label: 'bonusTargets.form.yil',
        required: true,
        defaultValue: new Date().getFullYear(),
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'ceyrek', type: 'select', label: 'bonusTargets.form.ceyrek',
        required: true,
        defaultValue: 1,
        options: [{ value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' }],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      // team_id ve user_id: ikisinden EN FAZLA biri seçilebilir. İkisi boşsa
      // şirket geneli hedeftir. DB CHECK constraint XOR'u zorlar.
      {
        name: 'team_id', type: 'select', label: 'bonusTargets.form.team',
        options: [{ value: '', label: '— (Yok)' }],
        helperText: 'bonusTargets.form.scopeHelp',
      },
      {
        name: 'user_id', type: 'select', label: 'bonusTargets.form.user',
        options: [{ value: '', label: '— (Yok)' }],
      },
      {
        name: 'hedef_tutar', type: 'number', label: 'bonusTargets.form.hedefTutar',
        required: true, step: 0.01,
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      { name: 'aciklama', type: 'textarea', label: 'bonusTargets.form.aciklama', rows: 2, fullWidth: true },
    ],
    title: {
      add: 'bonusTargets.form.titles.add',
      edit: 'bonusTargets.form.titles.edit',
    },
  },

  // ─── Cirolarım (kullanıcı kendi prim cirosunu girer) ───────────────────
  userRevenueEntries: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        showIf: (_userData, currentUser) => currentUser?.role === 'ROOT',
      },
      {
        name: 'yil', type: 'number', label: 'userRevenueEntries.form.yil',
        required: true,
        defaultValue: new Date().getFullYear(),
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'ceyrek', type: 'select', label: 'userRevenueEntries.form.ceyrek',
        required: true,
        defaultValue: 1,
        options: [{ value: 1, label: 'Q1' }, { value: 2, label: 'Q2' }, { value: 3, label: 'Q3' }, { value: 4, label: 'Q4' }],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      {
        name: 'ciro_kanali', type: 'select', label: 'userRevenueEntries.form.ciroKanali',
        required: true,
        options: [
          { value: 'SATIS_CIROSU',        labelKey: 'userRevenueEntries.kanal.SATIS_CIROSU' },
          { value: 'PROJE_YAZIM_CIROSU',  labelKey: 'userRevenueEntries.kanal.PROJE_YAZIM_CIROSU' },
          { value: 'ONAY_SONRASI_CIROSU', labelKey: 'userRevenueEntries.kanal.ONAY_SONRASI_CIROSU' },
        ],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      // Ciro Türü — Ayarlar > Ciro Türleri (bonus_revenue_types) listesinden.
      // Options page seviyesinde dolduruluyor.
      {
        name: 'bonus_revenue_type_id', type: 'select',
        label: 'userRevenueEntries.form.ciroTuru',
        required: true,
        options: [],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      // Firma her zaman gerekli (DB FK'leri firma üzerinden gidiyor olmasa da
      // referans bütünlüğü için UX'te zorunlu).
      {
        name: 'firm_id', type: 'select', label: 'userRevenueEntries.form.firm',
        required: true,
        options: [],
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      // SATIS_CIROSU → contract_id zorunlu (DB CHECK constraint).
      {
        name: 'contract_id', type: 'select', label: 'userRevenueEntries.form.contract',
        options: [],
        showIf: (formData) => formData.ciro_kanali === 'SATIS_CIROSU',
      },
      // PROJE_YAZIM_CIROSU veya ONAY_SONRASI_CIROSU → job_id zorunlu.
      {
        name: 'job_id', type: 'select', label: 'userRevenueEntries.form.job',
        options: [],
        showIf: (formData) =>
          formData.ciro_kanali === 'PROJE_YAZIM_CIROSU' ||
          formData.ciro_kanali === 'ONAY_SONRASI_CIROSU',
      },
      // Doldurma Modu — ONAY_SONRASI icinde iki secenek:
      //   auto  → "Otomatik Doldur" (default): sistem seçili aylar + kural
      //           uzerinden tutari hesaplar, X ve Y otomatik gelir (gizli).
      //   manual → Kullanici X ve tutari elle girer; Y sistem hesabini
      //           gosterir (root olmayanlar readonly).
      // Kullanicinin spec'i: "Otomatik doldur basınca doldursun, altına manuel
      // doldur alanı olsun diğer alanlar alsın x'i tutarı manuel girsin,
      // Y görünsün".
      // BURASI KURALSIZ TABAN HAL. "Onay sonrasi TUBITAK'ta otomatik
      // doldur gosterme" kurali burada DEGIL — is tipi `showIf`in
      // imzasina (formData, currentUser) ulasmiyor. Kural, firma/is
      // listesini goren buildRevenueFormFields icinde bu alanin ve
      // asagidaki secili_aylar + ay_sayisi alanlarinin showIf'ini
      // daraltarak uygulaniyor (utils/revenueFillMode.js).
      {
        name: 'fill_mode',
        type: 'buttonGroup',
        label: 'userRevenueEntries.form.fillMode',
        defaultValue: 'auto',
        options: [
          { value: 'auto',   labelKey: 'userRevenueEntries.form.fillModeAuto' },
          { value: 'manual', labelKey: 'userRevenueEntries.form.fillModeManual' },
        ],
        showIf: (formData) => formData.ciro_kanali === 'ONAY_SONRASI_CIROSU',
      },
      // Seçili Aylar — ONAY_SONRASI + auto modda. Kullanici prim istedigi
      // aylari secer; tutar bu aylarin pickMonthlyForMonth toplamindan
      // otomatik hesaplanir. Manuel modda bu alan gizlenir.
      {
        name: 'secili_aylar',
        type: 'multiselect',
        label: 'userRevenueEntries.form.seciliAylar',
        helperText: 'userRevenueEntries.form.seciliAylarHelper',
        showIf: (formData) =>
          formData.ciro_kanali === 'ONAY_SONRASI_CIROSU'
          && (formData.fill_mode ?? 'auto') === 'auto',
        options: [
          { value: 1,  labelKey: 'userRevenueEntries.form.months.1'  },
          { value: 2,  labelKey: 'userRevenueEntries.form.months.2'  },
          { value: 3,  labelKey: 'userRevenueEntries.form.months.3'  },
          { value: 4,  labelKey: 'userRevenueEntries.form.months.4'  },
          { value: 5,  labelKey: 'userRevenueEntries.form.months.5'  },
          { value: 6,  labelKey: 'userRevenueEntries.form.months.6'  },
          { value: 7,  labelKey: 'userRevenueEntries.form.months.7'  },
          { value: 8,  labelKey: 'userRevenueEntries.form.months.8'  },
          { value: 9,  labelKey: 'userRevenueEntries.form.months.9'  },
          { value: 10, labelKey: 'userRevenueEntries.form.months.10' },
          { value: 11, labelKey: 'userRevenueEntries.form.months.11' },
          { value: 12, labelKey: 'userRevenueEntries.form.months.12' },
        ],
      },
      {
        name: 'tutar', type: 'number', label: 'userRevenueEntries.form.tutar',
        required: true, step: 0.01,
        validation: { required: true, requiredMessage: 'modals.form.validation.required' },
      },
      // Ay Sayisi (Pay - x)
      //  - ROOT: ONAY_SONRASI kanaliyken HER modda (auto veya manual) gorur
      //    ve elle degistirir — sistem hesabini istedigi zaman override eder.
      //  - Non-ROOT: SADECE manual modda gorur (o modda elle girer).
      {
        name: 'ay_sayisi', type: 'number', label: 'userRevenueEntries.form.aySayisi',
        placeholder: 'userRevenueEntries.form.aySayisiPlaceholder',
        helperText: 'userRevenueEntries.form.aySayisiHelper',
        step: 1, min: 0,
        // Kuralsiz taban hal. Otomatik modda sistem x'i kendisi hesaplayip
        // yaziyor, o yuzden ROOT disindakine gosterilmiyor. Onay sonrasi
        // TUBITAK'ta mod 'manual'a zorlandigi icin alan orada aciliyor —
        // bu daraltma buildRevenueFormFields icinde (is tipi buraya
        // ulasmiyor).
        showIf: (data, currentUser) =>
          data?.ciro_kanali === 'ONAY_SONRASI_CIROSU'
          && (
            currentUser?.role === 'ROOT'
            || (data?.fill_mode ?? 'auto') === 'manual'
          ),
      },
      // Toplam Ay (Payda - y)
      //  - ONAY_SONRASI kanaliyken HERKESE HER modda gorunur (bilgi amacli).
      //  - Sadece ROOT duzenleyebilir; diger roller icin DISABLED (sistem
      //    hesabini gorurler ama uzerine yazamaz).
      {
        name: 'toplam_ay', type: 'number', label: 'userRevenueEntries.form.toplamAy',
        placeholder: 'userRevenueEntries.form.toplamAyPlaceholder',
        helperText: 'userRevenueEntries.form.toplamAyHelper',
        step: 1, min: 0,
        showIf: (data) => data?.ciro_kanali === 'ONAY_SONRASI_CIROSU',
        disabled: (_data, currentUser) => currentUser?.role !== 'ROOT',
      },
      { name: 'aciklama', type: 'textarea', label: 'userRevenueEntries.form.aciklama', rows: 2, fullWidth: true },
    ],
    title: {
      add: 'userRevenueEntries.modal.title',
      edit: 'userRevenueEntries.modal.editTitle',
    },
  },

  revenueCalculationRules: {
    fields: [
      {
        name: 'companyId',
        type: 'select',
        label: 'form.fields.company',
        required: true,
        options: [],
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.companyRequired',
        },
        // ROOT/non-ROOT ayrımı sayfa seviyesinde (customFormFields filter)
        // yapılıyor; showIf DynamicForm signature uyumsuzluğu nedeniyle
        // kullanılmıyor.
      },
      {
        name: 'job_type_id',
        type: 'select',
        label: 'revenueCalculationRules.form.jobType',
        // Satış cirosu kuralları iş türünden bağımsız; boş bırakılabilir.
        required: false,
        options: [],
        validation: {},
      },
      {
        name: 'revenue_channel',
        type: 'select',
        label: 'revenueCalculationRules.form.revenueChannel',
        required: true,
        // Statik 3 kanal: yazım, onay sonrası, satış. Sistem hep bu üçünden
        // birini bekler — bonus_revenue_rules'tan FK ile değil.
        options: [
          { value: 'YAZIM', labelKey: 'revenueCalculationRules.channels.YAZIM' },
          { value: 'ONAY_SONRASI', labelKey: 'revenueCalculationRules.channels.ONAY_SONRASI' },
          { value: 'SATIS', labelKey: 'revenueCalculationRules.channels.SATIS' },
        ],
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.revenueChannelRequired',
        },
      },
      {
        name: 'pricing_method_ids',
        type: 'multiselect',
        label: 'revenueCalculationRules.form.pricingMethod',
        required: true,
        options: [],
        fullWidth: true,
        // Birden fazla ücretlendirme şekli seçilirse her biri için ayrı kural
        // kaydı oluşturulur (UNIQUE constraint nedeniyle 1 method/kural).
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.pricingMethodRequired',
        },
      },
      {
        name: 'recurrence_type',
        type: 'select',
        label: 'revenueCalculationRules.form.recurrenceType',
        required: true,
        defaultValue: 'ONCE',
        options: [
          { value: 'ONCE', labelKey: 'revenueCalculationRules.recurrence.ONCE' },
          { value: 'PER_JOB', labelKey: 'revenueCalculationRules.recurrence.PER_JOB' },
          { value: 'PER_PROJECT', labelKey: 'revenueCalculationRules.recurrence.PER_PROJECT' },
          { value: 'DEFINED_MONTHS', labelKey: 'revenueCalculationRules.recurrence.DEFINED_MONTHS' },
        ],
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.recurrenceTypeRequired',
        },
      },
      {
        name: 'defined_months',
        type: 'number',
        label: 'revenueCalculationRules.form.definedMonths',
        showIf: (formData) => formData.recurrence_type === 'DEFINED_MONTHS',
        validation: {
          required: (formData) => formData?.recurrence_type === 'DEFINED_MONTHS',
          requiredMessage: 'revenueCalculationRules.form.validation.definedMonthsRequired',
        },
      },
      {
        name: 'valid_job_statuses',
        type: 'multiselect',
        label: 'revenueCalculationRules.form.validJobStatuses',
        options: [
          { value: 'YAZIMDA', labelKey: 'revenueCalculationRules.jobStatus.YAZIMDA' },
          { value: 'DEGERLENDIRMEDE', labelKey: 'revenueCalculationRules.jobStatus.DEGERLENDIRMEDE' },
          { value: 'ONAYLANDI', labelKey: 'revenueCalculationRules.jobStatus.ONAYLANDI' },
          { value: 'REDDEDILDI', labelKey: 'revenueCalculationRules.jobStatus.REDDEDILDI' },
          { value: 'KAPATILDI', labelKey: 'revenueCalculationRules.jobStatus.KAPATILDI' },
          { value: 'TAMAMLANDI', labelKey: 'revenueCalculationRules.jobStatus.TAMAMLANDI' },
          { value: 'DANISMANLIK_SONLANDIRILDI', labelKey: 'revenueCalculationRules.jobStatus.DANISMANLIK_SONLANDIRILDI' },
          { value: 'ORTAK_BULUNDU', labelKey: 'revenueCalculationRules.jobStatus.ORTAK_BULUNDU' },
          { value: 'ASAMA_BIR_BASLADI', labelKey: 'revenueCalculationRules.jobStatus.ASAMA_BIR_BASLADI' },
          { value: 'ASAMA_BIR_BITTI', labelKey: 'revenueCalculationRules.jobStatus.ASAMA_BIR_BITTI' },
          { value: 'ASAMA_IKI_BASLADI', labelKey: 'revenueCalculationRules.jobStatus.ASAMA_IKI_BASLADI' },
          { value: 'ASAMA_IKI_BITTI', labelKey: 'revenueCalculationRules.jobStatus.ASAMA_IKI_BITTI' },
        ],
        fullWidth: true,
      },
      {
        name: 'fee_source',
        type: 'select',
        label: 'revenueCalculationRules.form.feeSource',
        required: true,
        // Hesaplama tutarının nereden okunacağını belirler.
        options: [
          { value: 'MONTHLY_UNIT_FEE', labelKey: 'revenueCalculationRules.feeSource.MONTHLY_UNIT_FEE' },
          { value: 'QUARTERLY_TOTAL_FEE', labelKey: 'revenueCalculationRules.feeSource.QUARTERLY_TOTAL_FEE' },
          { value: 'NO_PREMIUM', labelKey: 'revenueCalculationRules.feeSource.NO_PREMIUM' },
        ],
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.feeSourceRequired',
        },
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'revenueCalculationRules.form.description',
        rows: 2,
        fullWidth: true,
      },
      {
        name: 'status',
        type: 'select',
        label: 'revenueCalculationRules.form.status',
        required: true,
        defaultValue: 'active',
        options: [
          { value: 'active', labelKey: 'revenueCalculationRules.form.statusActive' },
          { value: 'inactive', labelKey: 'revenueCalculationRules.form.statusInactive' },
        ],
        validation: {
          required: true,
          requiredMessage: 'revenueCalculationRules.form.validation.statusRequired',
        },
      },
    ],
    title: {
      add: 'revenueCalculationRules.form.titles.add',
      edit: 'revenueCalculationRules.form.titles.edit',
    },
  },

  // Dokuman Bankasi — DynamicCrudPage default add/edit modal'inda kullanilir.
  // __mode alani sayesinde ayni modal 4 farkli senaryoyu karsilar:
  //   'create'      -> yeni dokuman (title + description + file + notes + assignments)
  //   'meta'        -> mevcut dokumani duzenle (title/description; file/notes/assignments istege bagli)
  //   'version'     -> sadece yeni versiyon yukle (file + notes)
  //   'assignments' -> sadece atamalari degistir (assignments)
  // Mod, DocumentBankPage'in customTransformEditData'sinden gelir.
  documentBank: {
    fields: (() => {
      const modeOf = (d) => d?.__mode || (d?.id ? 'meta' : 'create');
      const inModes = (list) => (data) => list.includes(modeOf(data));
      return [
        {
          name: 'title',
          type: 'text',
          label: 'documentBank.fields.title',
          placeholder: 'documentBank.fields.title',
          autoFocus: true,
          required: (d) => ['create', 'meta'].includes(modeOf(d)),
          showIf: inModes(['create', 'meta']),
          validation: {
            required: (d) => ['create', 'meta'].includes(modeOf(d)),
            requiredMessage: 'documentBank.validation.titleRequired',
          },
        },
        {
          name: 'description',
          type: 'textarea',
          label: 'documentBank.fields.description',
          rows: 2,
          showIf: inModes(['create', 'meta']),
        },
        {
          name: 'file',
          type: 'file',
          label: 'documentBank.sections.file',
          placeholder: 'documentBank.dropzone.title',
          required: (d) => ['create', 'version'].includes(modeOf(d)),
          showIf: inModes(['create', 'meta', 'version']),
          validation: {
            required: (d) => ['create', 'version'].includes(modeOf(d)),
            requiredMessage: 'documentBank.validation.fileRequired',
          },
        },
        {
          name: 'notes',
          type: 'textarea',
          label: 'documentBank.fields.notes',
          placeholder: 'documentBank.fields.notesPlaceholder',
          rows: 2,
          showIf: inModes(['create', 'meta', 'version']),
        },
        {
          name: 'assignments',
          type: 'documentAssignments',
          label: 'documentBank.sections.assignments',
          showIf: inModes(['create', 'meta', 'assignments']),
        },
      ];
    })(),
    title: {
      add: 'documentBank.newDocument',
      edit: 'documentBank.editMeta',
    },
  },
};
